import { InfoOutlined } from "@mui/icons-material";
import React from "react";

function InfoAlert({ alertMessage }) {
  return (
    <div
      style={{
        display: "flex",
        gap: "12px",
        backgroundColor: "#F5FAFF",
        border: "1px solid #84CAFF",
        marginTop: "10px",
        padding: "16px",
        color: "#175CD3",
        borderRadius: "12px",
      }}
    >
      <InfoOutlined />
      <p style={{ margin: "0px" }}>{alertMessage}</p>
    </div>
  );
}

export default InfoAlert;
